<div class='previewModal'>
    <div class="modal-header">
        <h4 class="modal-title roboTitle" id="modal-basic-title">{{ 'users.editor.companyCreate' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
      
        <div class='row'>
            
            <div class='form-group col-5' style='margin-left: 10px'>
             
                <label for="nL" class="roboSubTitle">{{'users.personal.denominazione' | translate}}</label>
                <input class="form-control" type="text" id="nL" [(ngModel)]="this.azienda.denominazione">
            </div>

            <div *ngIf="this.me?.role == 'S'" class='form-group col-5' style='margin-left: 10px'>
             
                <label for="nL" class="roboSubTitle">{{ 'users.editor.environment' | translate }}</label>
                <!--<input class="form-control" type="text" id="nL" [(ngModel)]="this.azienda.environment_id">-->
                <input id="btnPass" id="btnPassEnv" type="text" class="form-control" [(ngModel)]="azienda.environment"
                    [ngbTypeahead]="searchEnv"  [inputFormatter]="formatterEnv" [resultFormatter]="formatterEnv"
                    [placeholder]="'placeholder.search' | translate" [editable]='false'
                    (selectItem)="azienda.environment_id = $event.item.id;" />

            </div>

            
        </div>
        <div class="row">
            <div class='form-group col-5' style='margin-left: 10px'>
             
                <label for="nL" class="roboSubTitle">Partita IVA</label>
                <input class="form-control" type="text" id="nL" [(ngModel)]="this.azienda.partitaiva">

            </div>
            <div class='form-group col-5' style='margin-left: 10px'>
             
                <label for="nL" class="roboSubTitle">Codice fiscale</label>
                <input class="form-control" type="text" id="nL" [(ngModel)]="this.azienda.codicefiscale">

            </div>

            
        </div>
        <div class="row">
            
            <div class='form-group col-5' style='margin-left: 10px'>
             
                <label for="nL" class="roboSubTitle">Email</label>
                <input class="form-control" type="text" id="nL" [(ngModel)]="this.azienda.email">

            </div>
        </div>
        
        
        
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">Chiudi</button>
        <button type="button" class="btn btn-outline-dark" (click)="salva()">Salva</button>
    </div>
    </div>